import { Accordion, Title } from '@mantine/core';
import type { AccordionProps } from '@mantine/core';

export interface TitleAccordionItem {
  value: string;
  label: string;
  children: React.ReactNode;
}

export interface TitleAccordionProps extends Omit<AccordionProps, 'children'> {
  /** Optional section heading shown above the accordion */
  sectionTitle?: string;
  /** Accordion items: value, label (shown in control), and panel content */
  items: TitleAccordionItem[];
}

/**
 * Reusable accordion with consistent control styling (Title order={3} size="xl")
 * and injectable section title and panel contents.
 */
export function TitleAccordion({
  sectionTitle,
  items,
  variant = 'separated',
  radius = 'md',
  ...accordionProps
}: TitleAccordionProps): JSX.Element {
  return (
    <>
      {sectionTitle != null && (
        <Title order={2} mb="md">
          {sectionTitle}
        </Title>
      )}
      <Accordion variant={variant} radius={radius} {...accordionProps}>
        {items.map(({ value, label, children }) => (
          <Accordion.Item key={value} value={value}>
            <Accordion.Control>
              <Title order={3} size="xl">
                {label}
              </Title>
            </Accordion.Control>
            <Accordion.Panel>{children}</Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
}
